/**
 * Mocks the `debounce` function from `lodash-es`.
 * The `debounce` function is used in the sort column header and
 * tests that use the sort functionality would fail otherwise.
 * This call should be placed at the top of the
 * unit test file (before the describe block).
 *
 * If an external file containing this mock is used, make
 * sure that the import is before any other imports.
 *
 * This function sets the mock for the current
 * file test suite where it is called/imported (doesn't bleed
 * into other test files).
 */
jest.mock('lodash-es', () => ({
  ...jest.requireActual('lodash-es'),
  debounce: (fn) => {
    fn.cancel = jest.fn();
    return fn;
  },
}));
